import { createContext } from 'react';

const proveedorContext = createContext();

export default proveedorContext;